package top.wcpe.allincore.dsl.compiler.diag

import top.wcpe.allincore.dsl.compiler.source.SourcePosition

/** 多源编译使用的内存源码提供者。 */
internal class InMemorySourcesProvider(
    sources: Map<String, String>,
) : SourceProvider {
    private val providers = sources.mapValues { (path, source) -> InMemorySourceProvider(path, source) }

    override fun fetchSnippet(position: SourcePosition): SourceSnippet? =
        providers[position.sourceId]?.fetchSnippet(position)
}
